module.exports = __webpack_public_path__ + "img/typing.4fd2a191.png";